import { KycStatusIcon } from './KycStatusIcon';
import React from 'react';
import { useIntl } from 'react-intl';
import { VerificationStatus } from '@lucky7ventures/bff-types';

const KYC_STATUS_TRANSLATION: Record<number, string> = {
  [VerificationStatus.Approved]: 'settings.verify.approved',
  [VerificationStatus.Requested]: 'settings.verify.requested',
  [VerificationStatus.Rejected]: 'settings.verify.rejected',
  [VerificationStatus.Processing]: 'settings.verify.pending',
  [VerificationStatus.UserRequested]: 'settings.verify.requested',
  // Specific for Source of Wealth Supporting Documents. This
  // status means the document request is pending, and waiting for
  // another document to be approved. Source of Wealth Supporting
  // Documents cannot be requested without SOW Questionnaire
  // being approved in the first place.
  [VerificationStatus.PendingRequest]: 'settings.verify.pendingRequest',
};

export function KycSection({
  status,
  title,
  children,
}: {
  status: VerificationStatus;
  title: string;
  children: React.ReactNode;
}): JSX.Element {
  const intl = useIntl();

  const showContent = (): boolean => {
    // Approved or pending status => we want to show only the header
    if ([VerificationStatus.Approved, VerificationStatus.Processing].includes(status)) {
      return false;
    }

    // for other statuses we want to show the children
    return true;
  };

  const statusText = (status: VerificationStatus): string | null => {
    const translationKey = KYC_STATUS_TRANSLATION[status];

    if (!translationKey) {
      return '';
    }

    return intl.formatMessage({ id: translationKey });
  };

  return (
    <div className="rounded bg-white p-6 w-full">
      <div className="align-center flex justify-between">
        <div>
          <h3 className="my-0 mr-2 text-xl font-bold">{title}</h3>
          <div className="text-sm">{statusText(status)}</div>
        </div>
        <KycStatusIcon id={status} />
      </div>
      {showContent() && (
        <div className="mt-4 border-t pt-4">
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}
